import { render, staticRenderFns } from "./Kaart.vue?vue&type=template&id=231b9dd2&scoped=true"
import script from "./Kaart.vue?vue&type=script&lang=js"
export * from "./Kaart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231b9dd2",
  null
  
)

export default component.exports